import { Panels } from './panels.js';

export default Array.from(document.querySelectorAll('.panels')).map(p => new Panels(p));

document.addEventListener('facet:refresh', () => {
	
	Array.from(document.querySelectorAll('.panels')).filter( p => ! p.dataset.panelsInit ).map( p => new Panels(p) );
});
